import { ITranslationService } from "angular-i18next";
import { i18nextOptions } from "./i18nextOptions";

export const localeIdFactory = ({ language }: ITranslationService) => language || i18nextOptions.fallbackLng;
